// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("./IconV5.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
let ClientPropertyLocation_property_graphql = require("../../../__generated__/ClientPropertyLocation_property_graphql.bs.js");
let ClientPropertyLocation_propertyLocation_graphql = require("../../../__generated__/ClientPropertyLocation_propertyLocation_graphql.bs.js");

let convertFragment = ClientPropertyLocation_property_graphql.Internal.convertFragment;

let convertFragment$1 = ClientPropertyLocation_propertyLocation_graphql.Internal.convertFragment;

function ClientPropertyLocation$Address(props) {
  let locationDisplay = props.locationDisplay;
  let address = props.address;
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("div", {
      children: address !== undefined ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
              children: address
            }),
            JsxRuntime.jsx("div", {
              children: locationDisplay,
              className: "text-lg text-zinc-600"
            })
          ]
        }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx("div", {
              children: locationDisplay
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(IconV5.make, {
                    icon: "lock",
                    size: 16,
                    className: "text-zinc-600"
                  }),
                  JsxRuntime.jsx("div", {
                    children: "Hidden Address"
                  })
                ],
                className: "flex flex-row items-center gap-1 lg:before:content-['('] lg:after:content-[')']"
              }),
              className: "text-xl text-zinc-600"
            })
          ]
        }),
      className: "flex flex-col lg:flex-row items-baseline gap-2"
    }),
    className: "text-zinc-700 font-medium text-2xl sm:text-3xl"
  });
}

function ClientPropertyLocation$ByPropertyLocation(props) {
  let propertyLocation = RescriptRelay_Fragment.useFragment(ClientPropertyLocation_propertyLocation_graphql.node, convertFragment$1, props.propertyLocation);
  switch (propertyLocation.__typename) {
    case "PropertyLocationWithHiddenAddress" :
      return JsxRuntime.jsx(ClientPropertyLocation$Address, {
        address: undefined,
        locationDisplay: propertyLocation.locationDisplay
      });
    case "PropertyLocationWithVisibleAddress" :
      return JsxRuntime.jsx(ClientPropertyLocation$Address, {
        address: propertyLocation.address,
        locationDisplay: propertyLocation.locationDisplay
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected property location ` + propertyLocation._0);
  }
}

let ByPropertyLocation = {
  make: ClientPropertyLocation$ByPropertyLocation
};

function ClientPropertyLocation$WithoutErrorBoundary(props) {
  let property = RescriptRelay_Fragment.useFragment(ClientPropertyLocation_property_graphql.node, convertFragment, props.property);
  return JsxRuntime.jsx(ClientPropertyLocation$ByPropertyLocation, {
    propertyLocation: property.propertyLocation.fragmentRefs
  });
}

function ClientPropertyLocation(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "location",
    children: JsxRuntime.jsx(ClientPropertyLocation$WithoutErrorBoundary, {
      property: props.property
    })
  });
}

let make = ClientPropertyLocation;

exports.ByPropertyLocation = ByPropertyLocation;
exports.make = make;
/* IconV5 Not a pure module */
